import { ReactElement, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

//Admin authentication guard
const UnProtectedRoutes = ({ component }: { component: ReactElement }) => {
	const [loading, setLoading] = useState(true);
	const navigate = useNavigate();
	const pathName = window.location.pathname;

	useEffect(() => {
		const profile =
			localStorage.getItem('profile') &&
			JSON.parse(localStorage.getItem('profile')!);

		if (profile?.token && pathName !== '/privacy-policy') {
			profile?.role !== 1
				? navigate('/dashboard')
				: navigate('/admin/dashboard');
		}

		setLoading(false);
	}, [component]);

	return <>{!loading && component}</>;
};

export default UnProtectedRoutes;
